/**
 * Builds the toast message for a failed publication save.
 *
 * The docs admin API returns validation failures as plain text such as
 * `Validation error: Parent document ID is required for version 2 or higher.`
 * The prefix before the first colon is dropped. Anything that is not a short
 * text message (an error object, a JSON or HTML error page) falls back.
 *
 * @param data the `data` of a failed ApiResponse
 * @param fallback the message to use when no readable text is available
 * @returns the message to show the user
 */
export const getSaveErrorMessage = (data: unknown, fallback: string): string => {
    if (typeof data !== 'string') {
        return fallback;
    }
    const text = data.trim();
    if (text === '' || text.startsWith('{') || text.startsWith('<')) {
        return fallback;
    }
    const separatorIndex = text.indexOf(':');
    const message = separatorIndex === -1 ? text : text.slice(separatorIndex + 1).trim();
    return message || fallback;
};
